import normalizeEmailOriginal from 'validator/lib/normalizeEmail';
import { isProd } from './environment';
import errorWithCode from './error-with-code';

/**
 * This helper function makes sure we only normalize in Production environment
 */
export const normalizeEmail = (email: string): string => {
  if (isProd) {
    // clean email
    const normalizedEmail = normalizeEmailOriginal(email);
    if (typeof normalizedEmail === 'string') {
      return normalizedEmail;
    } else {
      throw errorWithCode(400, 'normalizeEmail returned false', { email });
    }
  }
  return email;
};
